@if (!data.bulkJobId) {
  <zag-selection-summary-panel
    [sections]="data.sections"
    [selectedCount]="data.selectedCount"
    [totalCount]="data.selectedCount"
    (actionSelected)="onSectionSelected($event)"
    (leaveSelection)="close()"
  />
}
